import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import { Container, Card, CardBody, CardTitle, Row, Col } from "reactstrap";
import AddEdit from "./AddEdit";
import DatatableTables from "../../components/Tables/DatatableTables";
import { getLoanApplicationListAction } from "../../store/actions";
import { toast } from "react-toastify";
import IsLoadingHOC from "../../components/IsLoadingHOC";
import { Link, Redirect, useParams } from "react-router-dom";
import { getTokenDetails, parseJwt } from "../../helpers/common_helper";
const LoanApplication = props => {
  const [columns, setColumns] = useState([]);
  const [listData, setListData] = useState([]);
  const [userTokenData, setUserTokenData] = useState({});
  const { type, id } = useParams();
  const pageNo = 1,
    pageLimit = 100;
  useEffect(() => {
    loadLoanApplicatinonList();
    let localData = localStorage.getItem("authUser")
      ? JSON.parse(localStorage.getItem("authUser"))
      : {};
    const accessToken = localData.accessToken ? localData.accessToken : "";
    if (accessToken) {
      let d = parseJwt(accessToken);
      setUserTokenData(d ? d : {});
    }
  }, []);

  const loadLoanApplicatinonList = () => {
    setListData([]);
    setColumns([]);
    props.setLoading(true);
    getLoanApplicationListAction(pageNo, pageLimit)
      .then(resp => {
        if (resp.httpCode >= 200 && resp.httpCode <= 299) {
          if (resp.data) {
            if (Array.isArray(resp.data.rows)) {
              let data = resp.data.rows.map(v => {
                return {
                  id: v["_id"] ? v["_id"] : v.id,
                  name: `${v.applicant.fname} ${v.applicant.lname}`,
                  code: v.applicationCode,
                  email: v.applicant.email,
                  cellNo: v.applicant.phone,
                  requestedAmt: v.loanDetails.requestedAmt,
                  requestedTenure: v.loanDetails.requestedTenure,
                  applicantId: v.applicant.id,
                };
              });
              setListData(data);
              setColumns([
                {
                  dataField: "code",
                  text: "ApplicationNo",
                  sort: true,
                },
                {
                  dataField: "name",
                  text: "Name",
                  sort: true,
                },
                {
                  dataField: "cellNo",
                  text: "CellNo",
                  sort: true,
                },
                {
                  dataField: "email",
                  text: "Email",
                  sort: true,
                },
                {
                  dataField: "requestedAmt",
                  text: "Amount",
                  sort: true,
                },
                {
                  dataField: "requestedTenure",
                  text: "Tenure",
                  sort: true,
                },
                {
                  dataField: "id",
                  text: "Action",
                  formatter: ActionButtons,
                  sort: false,
                },
              ]);
            }
          }
        }
        props.setLoading(false);
      })
      .catch(err => {
        toast.error("Error in Loan Application List load");
        console.log("....", err);
        props.setLoading(false);
      });
  };
  const ActionButtons = (cell, row, rowIndex, formatExtraData) => {
    return (
      <Link
        title="Edit"
        className="text-success fa fa-edit"
        to={`/loanfile/edit/${row.id}:${row.applicantId}`}
      />
    );
  };
  if (type === "new" || type === "edit") {
    return (
      <React.Fragment>
        {!id && type === "edit" ? <Redirect to={`/loanfile`} /> : ""}
        <div className="page-content">
          <MetaTags>
            <title>LoanPeCar Admin Portal Add/Edit Loan Application</title>
          </MetaTags>
          <Container fluid>
            <Row>
              <Col className="col-12">
                <AddEdit
                  editDisabled={false}
                  id={id.split(":")[0]}
                  personId={id.split(":")[1]}
                />
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>LoanPeCar Admin Portal Loan Application</title>
          </MetaTags>

          <Container fluid>
            <Row>
              <Col className="col-12">
                <Card>
                  <CardBody>
                    <CardTitle className="h4">
                      Loan Application List
                      <Link
                        to="/loanfile/new"
                        className="btn btn-success"
                        style={{ float: "right" }}
                      >
                        Add Loan Application
                      </Link>
                    </CardTitle>
                    {columns.length > 0 ? (
                      <DatatableTables columns={columns} data={listData} />
                    ) : (
                      ""
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
};

export default IsLoadingHOC(LoanApplication, "Wait .....");
